/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerFindAllQueryResponse, JobsControllerFindAllQueryParams, JobsControllerFindAll401, JobsControllerFindAll403 } from "../../models/jobsController/JobsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { jobsControllerFindAll } from "../../clients/jobsService/jobsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const jobsControllerFindAllQueryKey = (params: JobsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/jobs'
}, ...(params ? [params] : [])] as const;
export type JobsControllerFindAllQueryKey = ReturnType<typeof jobsControllerFindAllQueryKey>;
export function jobsControllerFindAllQueryOptions(params?: JobsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = jobsControllerFindAllQueryKey(params);
  return queryOptions<JobsControllerFindAllQueryResponse, ResponseErrorConfig<JobsControllerFindAll401 | JobsControllerFindAll403>, JobsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return jobsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all jobs
 * {@link /api/v1/jobs}
 */
export function useJobsControllerFindAll<TData = JobsControllerFindAllQueryResponse, TQueryData = JobsControllerFindAllQueryResponse, TQueryKey extends QueryKey = JobsControllerFindAllQueryKey>(params?: JobsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<JobsControllerFindAllQueryResponse, ResponseErrorConfig<JobsControllerFindAll401 | JobsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? jobsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...jobsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<JobsControllerFindAll401 | JobsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}